// RED
export const RedSidely = '#FF5959';
// BLUE
export const PrimaryColor = '#4654E8';
export const PastelPrimaryColor = `color-mix(in oklab, ${PrimaryColor} 10%, white)`;
export const SidelyBlack = '#202020';
export const OnPrimaryColor = 'white';
// GREY
export const LightGreySidely = '#F7F7F9';
export const LightGreySidely2 = '#F1F4F8';
export const LightGreySidely3 = '#F5F5F7';
export const GreySidely = '#CED7E3';
export const GreySidely2 = '#C2CFE0';
export const GreySidely3 = '#909EB0';
export const GreySidely4 = '#788DA8';
export const DarkGreySidely = '#254153';
export const DarkGreySidely2 = '#707683';
export const ScrollbarColor = `color-mix(in oklab, ${DarkGreySidely} 60%, transparent)`;

// GREEN
export const GreenSidely = '#2ED47A';

// ORANGE
export const OrangeSidely = '#FEA240';

export const BorderColor = '#EBEFF2';
export const BorderColor2 = '#E2E2E2';

export const SurfaceColor = 'white';
export const BackgroundColor = LightGreySidely;
export const HeaderColor = '#FAFAFC';

export const FilterPrimaryColor =
	'brightness(0) saturate(100%) invert(19%) sepia(89%) saturate(4447%) hue-rotate(247deg) brightness(101%) contrast(98%)';
export const FilterRed =
	'invert(56%) sepia(26%) saturate(5134%) hue-rotate(326deg) brightness(102%) contrast(94%)';
export const FilterWhite = 'brightness(1000%) contrast(1000%)';
export const FilterGreen =
	'invert(66%) sepia(48%) saturate(646%) hue-rotate(94deg) brightness(95%) contrast(87%)';
export const FilterDarkGrey2 =
	'brightness(0) saturate(100%) invert(47%) sepia(16%) saturate(302%) hue-rotate(183deg) brightness(93%) contrast(87%)';
export const FilterLightGrey =
	'brightness(0) saturate(100%) invert(47%) sepia(16%) saturate(302%) hue-rotate(183deg) brightness(200%) contrast(50%)';
export const DisabledColor = '#E9ECEF';

export const AiGradiant =
	'linear-gradient(to left, #A855F7 0%,  color-mix(in oklab, rgb(152, 113, 251) 50%, var(--primary-color)) 49%, var(--primary-color) 71%)';

// BLUE (color list)
export const CeruleanSidely = '#0393D0';
export const SteelBlueSidely = '#227C9D';
export const PeriwinkleBlueSidely = '#4895FF';
export const SkyBlueSidely = '#72ACFB';
// TEAL
export const TealSidely = '#12A39C';
export const BrightTealSidely = '#12CBC3';
export const LightTealSidely = '#A0CFD3';
export const LightCyanSidely = '#C6E4E7';
// GREEN (color list)
export const ForestGreenSidely = '#0C6836';
export const EmeraldSidely = '#2A9D5F';
export const LimeGreenSidely = '#87F16D';
// YELLOW / LIME
export const OliveSidely = '#AA9A0E';
export const YellowGreenSidely = '#C0D374';
export const LimeYellowSidely = '#D2F34E';
export const YellowSidely = '#DECC24';
export const AmberSidely = '#FEC940';
export const BrightYellowSidely = '#FFEA2C';
// ORANGE (color list)
export const BurntOrangeSidely = '#CE5A28';
export const CoralSidely = '#FF814B';
// RED (color list)
export const BrightRedSidely = '#ED383F';
export const SalmonSidely = '#F5767B';
export const LightPinkSidely = '#EA9EA5';
export const BlushSidely = '#F8CACE';
// PURPLE / INDIGO
export const IndigoSidely = '#5C5CF2';
export const PlumSidely = '#726680';
export const MauveSidely = '#7C7287';
export const MediumPurpleSidely = '#8282C6';
export const LavenderSidely = '#9F9FED';
export const LightLavenderSidely = '#CBCBF4';
// GREY / SLATE (color list)
export const SlateSidely = '#4B586A';
export const CoolGreySidely = '#90A0B7';
export const BlueGreySidely = '#A8B5C7';
// BROWN / WARM NEUTRAL
export const BrownSidely = '#92572B';
export const SiennaSidely = '#B6784B';
export const PeachSidely = '#CEA07E';
export const LightPeachSidely = '#E5C0A4';
